import script from "./Aboutus.vue?vue&type=script&setup=true&lang=js"
export * from "./Aboutus.vue?vue&type=script&setup=true&lang=js"

import "./Aboutus.vue?vue&type=style&index=0&id=4dda25ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dda25ca"]])

export default __exports__